import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import QueDibujo from "@/pages/QueDibujo";
import PenBattle from "@/pages/PenBattle";
import EmojiBattle from "@/pages/EmojiBattle";
import ObjetoImposible from "@/pages/ObjetoImposible";
import ClienteImposible from "@/pages/ClienteImposible";
import PaletaMaldita from "@/pages/PaletaMaldita";
import TipografiaTorturada from "@/pages/TipografiaTorturada";
import LogoEn60 from "@/pages/LogoEn60";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminCostos from "@/pages/AdminCostos";
import AdminTemplates from "@/pages/AdminTemplates";
import AdminCategorias from "@/pages/AdminCategorias";
import SharedPrompt from "@/pages/SharedPrompt";

const RequireAdmin = ({ children }) => {
  const token = localStorage.getItem("guango_admin_token");
  if (!token) return <Navigate to="/admin" replace />;
  return children;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster position="top-center" richColors closeButton />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/que-dibujo" element={<QueDibujo />} />
          <Route path="/pen-battle" element={<PenBattle />} />
          <Route path="/emoji-battle" element={<EmojiBattle />} />
          <Route path="/objeto-imposible" element={<ObjetoImposible />} />
          <Route path="/cliente-imposible" element={<ClienteImposible />} />
          <Route path="/paleta-maldita" element={<PaletaMaldita />} />
          <Route path="/tipografia-torturada" element={<TipografiaTorturada />} />
          <Route path="/logo-en-60" element={<LogoEn60 />} />
          <Route path="/p/:id" element={<SharedPrompt />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<RequireAdmin><AdminDashboard /></RequireAdmin>} />
          <Route path="/admin/costos" element={<RequireAdmin><AdminCostos /></RequireAdmin>} />
          <Route path="/admin/prompts-ia" element={<RequireAdmin><AdminTemplates /></RequireAdmin>} />
          <Route path="/admin/categorias" element={<RequireAdmin><AdminCategorias /></RequireAdmin>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
